import React from 'react';
import { Box, Typography, Paper, Avatar } from '@mui/material';
import { NotificationsActive } from '@mui/icons-material';

interface NotificationPreviewProps {
  title: string;
  body: string;
  imageUrl?: string;
  appName?: string;
}

const NotificationPreview: React.FC<NotificationPreviewProps> = ({
  title,
  body,
  imageUrl,
  appName = 'SweatSocial',
}) => {
  // Replace template variables with sample data for preview
  const sampleReplace = (text: string) =>
    text
      .replace(/\{\{name\}\}/gi, 'Priya')
      .replace(/\{\{city\}\}/gi, 'Mumbai');

  const previewTitle = sampleReplace(title) || 'Notification Title';
  const previewBody = sampleReplace(body) || 'Notification body text goes here...';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase' }}>
        Preview
      </Typography>

      {/* Phone frame */}
      <Box
        sx={{
          width: 280,
          bgcolor: '#1a1a2e',
          borderRadius: 4,
          p: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          border: '3px solid #2d2d44',
        }}
      >
        {/* Status bar */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, px: 0.5 }}>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.65rem' }}>
            9:41
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.65rem' }}>
            ●●● WiFi 🔋
          </Typography>
        </Box>

        {/* Notification card */}
        <Paper
          elevation={0}
          sx={{
            bgcolor: 'rgba(255,255,255,0.12)',
            backdropFilter: 'blur(10px)',
            borderRadius: 2,
            p: 1.5,
            border: '1px solid rgba(255,255,255,0.15)',
          }}
        >
          {/* App header */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Avatar
              sx={{
                width: 18,
                height: 18,
                bgcolor: '#2196f3',
                fontSize: '0.55rem',
                fontWeight: 700,
              }}
            >
              SS
            </Avatar>
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.65rem', fontWeight: 600 }}>
              {appName.toUpperCase()}
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.6rem', ml: 'auto' }}>
              now
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#ffffff',
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  lineHeight: 1.3,
                  mb: 0.5,
                }}
              >
                {previewTitle}
              </Typography>
              <Typography
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  fontSize: '0.72rem',
                  lineHeight: 1.4,
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {previewBody}
              </Typography>
            </Box>
            {imageUrl ? (
              <Box
                component="img"
                src={imageUrl}
                alt="notification"
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 1,
                  objectFit: 'cover',
                  flexShrink: 0,
                }}
                onError={(e: any) => { e.target.style.display = 'none'; }}
              />
            ) : (
              <Avatar sx={{ width: 40, height: 40, bgcolor: '#2196f3', flexShrink: 0 }}>
                <NotificationsActive sx={{ fontSize: 18 }} />
              </Avatar>
            )}
          </Box>
        </Paper>

        {/* Home indicator */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Box sx={{ width: 100, height: 4, bgcolor: 'rgba(255,255,255,0.3)', borderRadius: 2 }} />
        </Box>
      </Box>

      <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', maxWidth: 220 }}>
        {`{{name}}`} will be replaced with each user's actual name
      </Typography>
    </Box>
  );
};

export default NotificationPreview;
